import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MedicalSpecialty } from '@pixacare/domain';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Cacheable } from 'ts-cacheable';

@Injectable({
  providedIn: 'root',
})
export class MedicalSpecialtiesHttpService {
  private readonly httpClient = inject(HttpClient);

  @Cacheable({ maxAge: 24 * 60 * 60 * 1000 }) // 24 hours
  getMedicalSpecialties(): Observable<MedicalSpecialty[]> {
    return this.httpClient.get<MedicalSpecialty[]>(`${environment.apiBaseUrl}/medicalSpecialty`);
  }
}
